import type { PhoneNumber } from '@urbanx/agx.campaigns.client';
import { EmailAddress, Name } from '@urbanx/agx-ui-components';

export interface DocuSignInfo {
  transferDocuSignOwnershipToAgent: boolean;
  agencyContact?: ContactInfo;
  agentEmail?: EmailAddress;
  sendToVendors: boolean;
  sendToBuyers: boolean;
  condition?: SendForDocuSigningType;
}

export interface ContactInfo {
  name: Name;
  email?: EmailAddress;
  phoneNumber?: PhoneNumber;
}

export enum SendForDocuSigningType {
  SendForDocuSigning = 'SendForDocuSigning',
  EmailToAgent = 'EmailToAgent',
}
